/**
 * Used to store dialog order on z axle, here we can determine which dialog on the top
 */
export class DialogStack {
  private static _instance: DialogStack

  private stack: HTMLElement[] = []

  public isOnTop(id: HTMLElement) {
    return this.stack[this.stack.length - 1] === id
  }

  public push(id: HTMLElement) {
    this.stack.push(id)
  }

  public pop() {
    this.stack.pop()
  }

  public checkIsEmpty() {
    return !this.stack || this.stack.length === 0
  }

  public remove(id: HTMLElement) {
    this.stack.splice(
      this.stack.findIndex((v) => v === id),
      1
    )
  }

  public static getInstance() {
    return this._instance || (this._instance = new this())
  }
}
